import { tasksRepo } from '@/constants/providers';
import { BusinessAreasKey } from '@/modules/BusinessAreas/queries/keys';
import { CompanyKeys } from '@/modules/Companies/queries';
import { OrganizationKeys } from '@/modules/Organizations/queries/keys';
import { UserKey } from '@/modules/Users/queries/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AttachUserTaskModel } from '../types/attach-user-task-model';
import { TaskKey } from './keys';

export const useAttachUserTask = () => {
  const queryClient = useQueryClient();
  return useMutation<void, unknown, AttachUserTaskModel>(
    (user) => tasksRepo.attachUserTask(user),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(OrganizationKeys.ALL);
        queryClient.invalidateQueries(BusinessAreasKey.ALL);
        queryClient.invalidateQueries(CompanyKeys.ALL);
        queryClient.invalidateQueries(TaskKey.ALL);
        queryClient.invalidateQueries(UserKey.ALL);
      },
    },
  );
};
